import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LocalizedLink } from "@/components/LocalizedLink";
import { useLanguage } from "@/hooks/useLanguage";

interface CTASectionProps {
  title?: string;
  description?: string;
  variant?: "default" | "emergency";
}

const CTASection = ({ 
  title,
  description,
  variant = "default"
}: CTASectionProps) => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-gradient-hero text-primary-foreground">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {title || t('cta.ready')}
          </h2>
          <p className="text-lg mb-6 opacity-95">
            {description || t('cta.ready.desc')}
          </p>
          <p className="text-sm mb-8 opacity-90 italic">
            {t('cta.disclaimer')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" variant="hero">
              <LocalizedLink to="/booking">{t('cta.consultation.button')}</LocalizedLink>
            </Button>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href="tel:8329303059">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                  <Phone className="mr-2 h-5 w-5" />
                  {t('cta.english')}: (832) 930-3059
                </Button>
              </a>
              <a href="tel:8323567254">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                  <Phone className="mr-2 h-5 w-5" />
                  {t('cta.spanish')}: (832) 356-7254
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
